import React from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "containers/slm/lease/SLMLeaseDetail.css";
import "./SLMRecordDeliverPanel.css";

export default function SLMRecordDeliverPanel({
  state,
  createId,
  onRedeliver,
  onDateChange,
  onBlur,
  onCheckBoxChange,
}) {
  return (
    <Card className="mb-2">
      <Card.Header>Record Deliver</Card.Header>
      <Card.Body>
        <Row className="mb-2">
          <Col className="text-right">
            <Button id={createId("action", "redeliver", "button")} variant="primary" size="sm" type="button" className="slm-compact-action-btn" onClick={onRedeliver}>
              Redeliver
            </Button>
          </Col>
        </Row>

        <Row className="g-2 mt-1">
          <Col>
            <Form.Group controlId="prev_delivery">
              <Form.Label id={createId("field", "prev-delivery", "label")}>Prev. Delivery Date</Form.Label>
              <br />
              <DatePicker
                id={createId("field", "prev-delivery", "input")}
                selected={state.prev_delivery !== null ? new Date(state.prev_delivery) : null}
                onChange={(e) => onDateChange(e, "prev_delivery")}
                onBlur={onBlur}
                dateFormat="dd/MM/yyyy"
                className="form-control slm-prev-delivery-date-input"
                disabled
                readOnly
              />
            </Form.Group>
          </Col>

          <Col>
            <Form.Group controlId="print_month">
              <Form.Label id={createId("field", "delivery-date", "label")}>Delivery Date</Form.Label>
              <br />
              <DatePicker id={createId("field", "delivery-date", "input")} selected={state.print_month !== null ? new Date(state.print_month) : null} onChange={(e) => onDateChange(e, "print_month")} onBlur={onBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mt-1 align-items-center">
          <Col>
            <Form.Group controlId="pending" className="pl-1 mb-0">
              <div className="d-flex align-items-center" style={{ gap: "0.9rem" }}>
                <Form.Check.Input
                  id={createId("field", "pending", "checkbox")}
                  checked={state.pending}
                  onChange={onCheckBoxChange}
                  name="pending"
                  type="checkbox"
                  className="position-static mt-0"
                />
                <Form.Label id={createId("field", "pending", "label")} htmlFor={createId("field", "pending", "checkbox")} className="mb-0">
                  Pending?
                </Form.Label>
              </div>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
